import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const itServicesSlice = createSlice({
  name: "services",
  initialState: {
    llms: {
      data: [],
      loading: false,
      error: null,
    },
    studentPortal: {
      data: [],
      loading: false,
      error: null,
    },
    office: {
      data: [],
      loading: false,
      error: null,
    },
    onlinePayment: {
      data: [],
      loading: false,
      error: null,
    },
    passwordManagment: {
      data: [],
      loading: false,
      error: null,
    },
    helpDesk: {
      data: [],
      loading: false,
      error: null,
    },

    ims: {
      data: [],
      loading: false,
      error: null,
    },
    councilling: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchLlmsStart(state) {
      state.llms.loading = true;
      state.llms.error = false;
    },
    fetchLlmsSuccess(state, action) {
      state.llms.loading = false;
      state.llms.data = action.payload;
    },
    fetchLlmsFailure(state, action) {
      state.llms.loading = false;
      state.llms.error = action.payload;
    },
    fetchStudentPortalStart(state) {
      state.studentPortal.loading = true;
      state.studentPortal.error = false;
    },
    fetchStudentPortalSuccess(state, action) {
      state.studentPortal.loading = false;
      state.studentPortal.data = action.payload;
    },
    fetchStudentPortalFailure(state, action) {
      state.studentPortal.loading = false;
      state.studentPortal.error = action.payload;
    },
    fetchOfficeStart(state) {
      state.office.loading = true;
      state.office.error = false;
    },
    fetchOfficeSuccess(state, action) {
      state.office.loading = false;
      state.office.data = action.payload;
    },
    fetchOfficeFailure(state, action) {
      state.office.loading = false;
      state.office.error = action.payload;
    },

    fetchOnlinePaymentStart(state) {
      state.onlinePayment.loading = true;
      state.onlinePayment.error = false;
    },
    fetchOnlinePaymentSuccess(state, action) {
      state.onlinePayment.loading = false;
      state.onlinePayment.data = action.payload;
    },
    fetchOnlinePaymentFailure(state, action) {
      state.onlinePayment.loading = false;
      state.onlinePayment.error = action.payload;
    },
    fetchPasswordManagmentStart(state) {
      state.passwordManagment.loading = true;
      state.passwordManagment.error = false;
    },
    fetchPasswordManagmentSuccess(state, action) {
      state.passwordManagment.loading = false;
      state.passwordManagment.data = action.payload;
    },
    fetchPasswordManagmentFailure(state, action) {
      state.passwordManagment.loading = false;
      state.passwordManagment.error = action.payload;
    },
    fetchHelpDeskStart(state) {
      state.helpDesk.loading = true;
      state.helpDesk.error = false;
    },
    fetchHelpDeskSuccess(state, action) {
      state.helpDesk.loading = false;
      state.helpDesk.data = action.payload;
    },
    fetchHelpDeskFailure(state, action) {
      state.helpDesk.loading = false;
      state.helpDesk.error = action.payload;
    },


    fetchImsStart(state) {
      state.ims.loading = true;
      state.ims.error = false;
    },
    fetchImsSuccess(state, action) {
      state.ims.loading = false;
      state.ims.data = action.payload;
    },
    fetchImsFailure(state, action) {
      state.ims.loading = false;
      state.ims.error = action.payload;
    },

    fetchCouncillingStart(state) {
      state.councilling.loading = true;
      state.councilling.error = false;
    },
    fetchCouncillingSuccess(state, action) {
      state.councilling.loading = false;
      state.councilling.data = action.payload;
    },
    fetchCouncillingFailure(state, action) {
      state.councilling.loading = false;
      state.councilling.error = action.payload;
    },
  },
});

export const {
  fetchLlmsStart,
  fetchLlmsSuccess,
  fetchLlmsFailure,
  fetchStudentPortalStart,
  fetchStudentPortalSuccess,
  fetchStudentPortalFailure,
  fetchOfficeStart,
  fetchOfficeSuccess,
  fetchOfficeFailure,
  fetchOnlinePaymentStart,
  fetchOnlinePaymentSuccess,
  fetchOnlinePaymentFailure,
  fetchPasswordManagmentStart,
  fetchPasswordManagmentSuccess,
  fetchPasswordManagmentFailure,
  fetchHelpDeskStart,
  fetchHelpDeskSuccess,
  fetchHelpDeskFailure,
  fetchImsStart,
  fetchImsSuccess,
  fetchImsFailure,
  fetchCouncillingStart,
  fetchCouncillingSuccess,
  fetchCouncillingFailure
} = itServicesSlice.actions;

export const fetchLlmsData = () => async (dispatch) => {
  dispatch(fetchLlmsStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getLLMS`
    );
    const data = response.data.data || [];
    dispatch(fetchLlmsSuccess(data));
  } catch (error) {
    dispatch(fetchLlmsFailure(error.message || "Something went wrong"));
  }
};


export const fetchCouncillingData = () => async (dispatch) => {
  dispatch(fetchCouncillingStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getStudentCounsellors`
    );
    const data = response.data.data || [];
    dispatch(fetchCouncillingSuccess(data));
  } catch (error) {
    dispatch(
      fetchCouncillingFailure(error.message || "Something went wrong")
    );
  }
};
export const fetchStudentPortalData = () => async (dispatch) => {
  dispatch(fetchStudentPortalStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getStudentPortal`
    );
    const data = response.data.data || [];
    dispatch(fetchStudentPortalSuccess(data));
  } catch (error) {
    dispatch(
      fetchStudentPortalFailure(error.message || "Something went wrong")
    );
  }
};

export const fetchOfficeData = () => async (dispatch) => {
  dispatch(fetchOfficeStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getOffice365`
    );
    const data = response.data.data || [];
    dispatch(fetchOfficeSuccess(data));
  } catch (error) {
    dispatch(fetchOfficeFailure(error.message || "Something went wrong"));
  }
};

export const fetchOnlinePaymentData = () => async (dispatch) => {
  dispatch(fetchOnlinePaymentStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getOnlinePayment`
    );
    const data = response.data.data || [];
    dispatch(fetchOnlinePaymentSuccess(data));
  } catch (error) {
    dispatch(
      fetchOnlinePaymentFailure(error.message || "Something went wrong")
    );
  }
};

export const fetchPasswordManagmnetData = () => async (dispatch) => {
  dispatch(fetchPasswordManagmentStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getPasswordManagement`
    );
    const data = response.data.data || [];
    dispatch(fetchPasswordManagmentSuccess(data));
  } catch (error) {
    dispatch(
      fetchPasswordManagmentFailure(error.message || "Something went wrong")
    );
  }
};

export const fetchHelpDeskData = () => async (dispatch) => {
  dispatch(fetchHelpDeskStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getHelpDesk`
    );
    const data = response.data.data || [];
    dispatch(fetchHelpDeskSuccess(data));
  } catch (error) {
    dispatch(
      fetchHelpDeskFailure(error.message || "Something went wrong")
    );
  }
};


export const fetchImsData = () => async (dispatch) => {
  dispatch(fetchImsStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getIMS`
    );
    const data = response.data.data || [];
    dispatch(fetchImsSuccess(data));
  } catch (error) {
    dispatch(
      fetchImsFailure(error.message || "Something went wrong")
    );
  }
};

export default itServicesSlice.reducer;
